import { Stack, TableCell, TableRow, Typography } from "@mui/material"
import { DateDisplay } from "lib/@components/dateDisplay"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { getProjectUsers } from "authoring/users/projects/controller/get-project-users"
import { UserAccessGroup } from "lib/@components/user-access/user-access-group"
import { navigateProject } from "../utilities/project-navigation"
import { ContextMenuBar } from "lib/@components/context-menu-bar"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"
import { grey } from "@mui/material/colors"
import { Secure } from "lib/authorization/secure"
import { setPhaseBadgeColor } from "authoring/lib/set-phase-badge-color"
import { BadgeLabel } from "routes/regime/plugins/regime-title/badge-label"
import {
    AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND,
    AUTHORING_MANAGE_WORK_PACKAGES_DEMAND,
} from "authoring/lib/constants/authoring-permissions.mjs"

export function ProjectRow({ project }) {
    const { setPreviousScroll, openProjectEdit } = useBoundContext()
    const { name, _modified, id, scopedScheduleIds, phase, groups } = project || {}
    const locked = isLockedToLegacy(phase)
    const projectUsers = getProjectUsers.useResults({ projectId: id })
    const badgeColor = setPhaseBadgeColor(phase)
    const scheduleCount = scopedScheduleIds?.length ?? 0

    return (
        <TableRow onClick={handleClick} sx={{ cursor: "pointer" }} hover data-cy="project-item">
            <TableCell
                sx={{ whiteSpace: "noWrap", maxWidth: { xs: 150 }, minWidth: { md: 450 } }}
                data-cy="project-title"
            >
                <TruncatedTypography>{name}</TruncatedTypography>
            </TableCell>
            <TableCell sx={{ whiteSpace: "noWrap" }} align="center">
                {projectUsers?.users?.length ? (
                    <UserAccessGroup max={3} users={projectUsers.users} sx={{ justifyContent: "center" }} />
                ) : (
                    <Typography>–</Typography>
                )}
            </TableCell>
            <TableCell sx={{ whiteSpace: "noWrap" }} align="right" data-cy="project-groups">
                <Typography>{groups?.length ?? 0}</Typography>
            </TableCell>
            <TableCell sx={{ whiteSpace: "noWrap" }} align="right" data-cy="project-schedules">
                <Stack direction={"row"} alignItems={"center"} justifyContent={"flex-end"} spacing={0.5}>
                    <Iconify icon={"mdi:drive-document"} sx={{ color: "#868686ff", height: "20px", width: "20px" }} />
                    <Typography>{scheduleCount}</Typography>
                </Stack>
            </TableCell>
            <TableCell sx={{ whiteSpace: "noWrap" }} data-cy="project-status">
                <BadgeLabel variant="subtitle2" sx={{ zoom: 0.8 }} color={badgeColor}>
                    {phase?.titleize()}
                </BadgeLabel>
            </TableCell>
            <TableCell sx={{ whiteSpace: "noWrap" }}>
                <DateDisplay date={_modified} />
            </TableCell>
            <TableCell data-cy="project-item-menu">
                <Stack direction={"row"} alignItems={"center"} justifyContent={"flex-end"} color={grey[500]}>
                    {locked && <Iconify icon={"material-symbols:lock"} sx={{ width: "20px", height: "20px" }} />}
                    <Secure
                        demand={[AUTHORING_MANAGE_WORK_PACKAGES_DEMAND, AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND]}
                        and={false}
                        fallback={<></>}
                    >
                        <ContextMenuBar
                            type="project"
                            project={project}
                            openProjectEdit={openProjectEdit}
                            buttonSx={{ color: grey[600] }}
                        />
                    </Secure>
                </Stack>
            </TableCell>
        </TableRow>
    )

    function handleClick() {
        setPreviousScroll()
        navigateProject(id)
    }
}
